import "toastr/build/toastr.min.css";
import { toast } from "react-toastify";
import { REPORT } from "../config/apiEndPoint";
import { POST } from "config/api.config";

/** POST `Report/not-interested/filter` */
export const submitNotInterestedReportFilterData = async (data = {}) => {
    try {
        const response = await POST(REPORT.NOT_INTERESTED_FILTER, data);
        return response;
    } catch (error) {
        toast.error(error?.message);
    }
};
